import React, { useState } from "react";
import { FormInput } from "../../../../components/form/index.js";
import { Search } from "../../../../components/search/Search.tsx";
import { SearchContextProvider } from "../../../../contexts/search.tsx";
import { useUsersContext } from "../../../../contexts/users.tsx";
import { RecipeAliment } from "../../../../models/recipes/recipeAliment.ts";
import CustomIcon from "../../../../components/CustomIcon.tsx";
import formatNumber from "../../../../models/helpers/formatNumber.ts";
import { Link } from "react-router";

export const RecipeAliments = ({
    recipeAliments,
    handleInputChange,
    handleAddItem,
    handleDeleteItem,
    mb = 3
}: {
    recipeAliments: RecipeAliment[];
    handleInputChange?: any;
    handleAddItem?: any;
    handleDeleteItem?: any;
    mb?: number;
}) => {
    const [showAddItem, setShowAddItem] = useState<boolean>(false);
    const {
        measurementUnits
    } = useUsersContext()

    const getMeasurementUnit = (recipeAliment: RecipeAliment) => {
        return measurementUnits.find(x => x.measurementUnitID == (recipeAliment.aliment?.measurementUnitID ?? 1))?.name
    }

    const getCalories = (recipeAliment: RecipeAliment) => {
        return formatNumber.ToFixed(recipeAliment.amount * (recipeAliment.aliment?.nutritionalValues?.calories ?? 0) / 100);
    }

    const getProtein = (recipeAliment: RecipeAliment) => {
        return formatNumber.ToFixed(recipeAliment.amount * (recipeAliment.aliment?.nutritionalValues?.protein ?? 0) / 100);
    }

    const getCarbohydrates = (recipeAliment: RecipeAliment) => {
        return formatNumber.ToFixed(recipeAliment.amount * (recipeAliment.aliment?.nutritionalValues?.carbohydrates ?? 0) / 100);
    }

    const getTotalFat = (recipeAliment: RecipeAliment) => {
        return formatNumber.ToFixed(recipeAliment.amount * (recipeAliment.aliment?.nutritionalValues?.totalFat ?? 0) / 100);
    }
    return (
        <div className="mb-3">{recipeAliments.length > 0 &&
            <ul className={`list-group ${mb && mb > 0 && `mb-${mb}`}`}>
                {recipeAliments.map((recipeAliment) => (
                    <li className="list-group-item d-flex flex-row justify-content-between px-2" key={recipeAliment.alimentID}>
                        <div className={`${handleAddItem ? 'w-60 pe-1' : ''} my-auto`}>
                            {!handleAddItem &&
                                <div className="d-flex flex-row mw-100">
                                    <Link className="nav-link" to={`/aliments/${recipeAliment.alimentID}`}><h6>{recipeAliment.aliment?.name}</h6></Link>
                                    <small className="text-muted">
                                        : {recipeAliment.amount}{getMeasurementUnit(recipeAliment)} - {getCalories(recipeAliment)}kCal
                                    </small>
                                </div>
                            }
                            {handleAddItem &&
                                <>
                                    <h6>{recipeAliment.aliment?.name}</h6>
                                    <div className="w-100 d-flex flex-row flex-wrap justify-content-around">
                                        <div className="w-100 d-flex flex-row flex-wrap">
                                            <div className="w-33 my-auto text-center">{recipeAliment.amount}{getMeasurementUnit(recipeAliment)}</div>
                                            <div className="w-33 my-auto text-center">{getCalories(recipeAliment)}kCal</div>
                                        </div>
                                        <div className="w-100 d-flex flex-row flex-wrap justify-content-around">
                                            <div className="w-33 my-auto text-center text-success">
                                                <CustomIcon name='protein' />
                                                {getProtein(recipeAliment)}g
                                            </div>
                                            <div className="w-33 my-auto text-center text-warning">
                                                <CustomIcon name='carbohydrates' />
                                                {getCarbohydrates(recipeAliment)}g
                                            </div>
                                            <div className="w-33 my-auto text-center text-danger">
                                                <CustomIcon name='fat' />
                                                {getTotalFat(recipeAliment)}g
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        {handleAddItem &&
                            <div className="d-flex flex-row w-40 h-fit my-auto">
                                <FormInput
                                    entity={recipeAliment}
                                    handleInputChange={handleInputChange}
                                    fieldName='amount'
                                    mappingName={`Aliment-${recipeAliment.alimentID}`}
                                    label='Amount'
                                    type="numeric"
                                    append={measurementUnits.find(x => x.measurementUnitID == recipeAliment.aliment?.measurementUnitID)?.name}
                                    mb={0}
                                />
                                <i className="bi bi-trash3 ms-2 my-auto" onClick={() => handleDeleteItem(recipeAliment)} />
                            </div>
                        }
                    </li>
                ))}
            </ul>
        }
            <ul className="list-group">
                {
                    handleAddItem && !showAddItem &&
                    <li className="list-group-item text-center px-2" onClick={() => setShowAddItem(true)}>Add item</li>
                }
            </ul>
            {showAddItem &&
                <SearchContextProvider>
                    <Search handleAddItem={handleAddItem} setShowSearch={setShowAddItem} displayResultsList disableRecipeSearch disableMealSearch />
                </SearchContextProvider>
            }
        </div>
    )
}